import React from "react";
import { Button, GridItem } from "@chakra-ui/react";
import {
  Form,
  PasswordInputs,
  Grid,
  ImageUploader,
  TextInput
} from "components";
import { User } from "../duck";
import { FormValues, getValidation, useUpdateUserProfile } from "./duck";

interface EditProps {
  initialValues: User;
  onCancel(): void;
  onSuccess(): void;
}

const Edit: React.FC<EditProps> = ({ initialValues, onCancel, onSuccess }) => {
  const update = useUpdateUserProfile(onSuccess);

  return (
    <Form<FormValues> {...getValidation(initialValues)} onSubmit={update}>
      <Grid>
        <GridItem>
          <TextInput
            name="firstName"
            label="First Name"
            placeholder="First Name"
          />
        </GridItem>
        <GridItem>
          <TextInput
            name="lastName"
            label="Last Name"
            placeholder="Last Name"
          />
        </GridItem>
        <GridItem>
          <TextInput
            name="email"
            label="Email"
            placeholder="Email"
            isDisabled
          />
        </GridItem>
        <PasswordInputs />
        <GridItem>
          <TextInput
            type="password"
            numeric
            name="pin"
            label="PIN"
            placeholder="PIN"
          />
        </GridItem>
        <GridItem colStart={1}>
          <ImageUploader name="image" label="Picture" />
        </GridItem>
      </Grid>

      <Form.Controls mt={6} submitText="Save">
        <Button variant="outline" colorScheme="gray" onClick={onCancel}>
          Cancel
        </Button>
      </Form.Controls>
    </Form>
  );
};

export default Edit;
